// extracted by mini-css-extract-plugin
module.exports = {"errorLabel":"Rj9LtFz"};